import { MOKA_SERVICE_HOST } from 'api/constants';

export const API_V1_GET_ROLES = `${MOKA_SERVICE_HOST}/account/v1/roles`;
